import { api } from '../../lib/api';

export const PO_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'PendingApproval', label: 'Pending approval', tone: 'warning' },
  { value: 'Approved', label: 'Approved', tone: 'success' },
  { value: 'Rejected', label: 'Rejected', tone: 'danger' },
  { value: 'Sent', label: 'Sent', tone: 'brand' },
  { value: 'PartiallyReceived', label: 'Partially received', tone: 'warning' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'neutral' },
  { value: 'Closed', label: 'Closed', tone: 'success' },
];

export const poStatusMeta = (status) =>
  PO_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

// Delivery/fulfilment tracking, parallel to the lifecycle status. 'None' (order not yet sent)
// is deliberately absent — it renders no badge.
export const DELIVERY_STATUSES = [
  { value: 'AwaitingConfirmation', label: 'Awaiting confirmation', tone: 'neutral' },
  { value: 'Confirmed', label: 'Confirmed', tone: 'brand' },
  { value: 'Shipped', label: 'Shipped', tone: 'brand' },
  { value: 'InTransit', label: 'In transit', tone: 'warning' },
  { value: 'Delayed', label: 'Delayed', tone: 'danger' },
  { value: 'Delivered', label: 'Delivered', tone: 'success' },
];

export const deliveryStatusMeta = (status) =>
  DELIVERY_STATUSES.find((s) => s.value === status) || null;

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const purchaseOrdersApi = {
  list: (params = {}) => api.get(`/purchase-orders${toQuery(params)}`),
  get: (id) => api.get(`/purchase-orders/${id}`),
  create: (payload) => api.post('/purchase-orders', payload),
  update: (id, payload) => api.putWithId(`/purchase-orders/${id}`, id, payload),
  remove: (id) => api.del(`/purchase-orders/${id}`),
  submit: (id) => api.post(`/purchase-orders/${id}/submit`, {}),
  cancel: (id) => api.post(`/purchase-orders/${id}/cancel`, {}),
  shortClose: (id, reason) => api.post(`/purchase-orders/${id}/short-close`, { reason: reason || null }),
  approve: (id, comment) => api.post(`/purchase-orders/${id}/approve`, { comment: comment || null }),
  reject: (id, reason) => api.post(`/purchase-orders/${id}/reject`, { reason }),
  send: (id, payload = {}) => api.post(`/purchase-orders/${id}/send`, payload),
  updateDeliveryStatus: (id, payload) => api.post(`/purchase-orders/${id}/delivery-status`, payload),
  convertFromRequisition: (requisitionId, assignments) =>
    api.post(`/purchase-orders/from-requisition/${requisitionId}`, { assignments: assignments?.length ? assignments : null }),
  listActivity: (id, params = {}) => api.get(`/purchase-orders/${id}/activity${toQuery(params)}`),
};
